import { render } from "./App.vue?vue&type=template&id=1cbc1357"
const script = {}

import "./App.vue?vue&type=style&index=0&id=1cbc1357&lang=css"

import exportComponent from "D:\\Jhy\\点甜官网\\2026最新版官网\\officialwebsite\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__